import React, { useState } from "react";
import {
  Form,
  Button,
  Alert,
  InputGroup,
  Container,
  Card,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { sendForgotPWDMobileNo_OTPApi } from "../ramnambook-registration/RamNamBookCRUD";
import { CountryData } from "../other-drop-downs/OtherDropDowns";
import Select from "react-select";

// ✅ Validation
const schema = Yup.object({
  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Enter valid 10-digit mobile number"),
});

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [countryID, setCountryID] = useState(22);
  const [countryDialCode, setCountryDialCode] = useState("+91");

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,

    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // ✅ Submit
  const onSubmit = async ({ mobileNumber }) => {
    try {
      const response = await sendForgotPWDMobileNo_OTPApi(
        countryID,
        mobileNumber,
        countryDialCode,
      );
      if (response.data.isSuccess == true) {
        if (countryID == 22) {
          toast.success(response.data.message);
          navigate("/verify-otp", {
            state: {
              mobileNumber,
              countryID,
              memberID: response.data.memberID,
            },
          });
        } else {
          toast.success("Your request sent successfully.");
          navigate("/verification-message", {
            replace: true,
          });
        }
      } else {
        toast.error(response.data.message);
      }
    } catch {
      toast.error("Failed to send OTP");
    }
  };

  return (
    <Container
      fluid
      className="vh-100 d-flex justify-content-center align-items-center bg-light"
    >
      <Card
        className="shadow rounded-4 p-4 w-100 text-center"
        style={{ maxWidth: "400px" }}
      >
        {/* ✅ TOP LOGO */}

        <img
          src="/assets/logo/barejadham1.png"
          alt="Logo"
          height="80"
          width="80"
          className="mx-auto mb-0"
        />

        <h6 className="text-danger fw-bold mb-2">Forgot Password</h6>
        {errors.root && <Alert variant="danger">{errors.root.message}</Alert>}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Country</Form.Label>

            <Select
              options={CountryData.map((x) => ({
                value: x.countryID,
                label: `${x.countryName} (${x.countryDialNumber})`,
                dialCode: x.countryDialNumber,
              }))}
              value={{
                value: countryID,
                label: `${
                  CountryData.find((x) => x.countryID === countryID)
                    ?.countryName
                } (${countryDialCode})`,
              }}
              onChange={(selected) => {
                setCountryID(selected.value);

                setCountryDialCode(selected.dialCode);
              }}
              placeholder="Search country..."
              isSearchable={true}
            />
          </Form.Group>

          {/* Mobile */}

          <Form.Group className="mb-4 text-start">
            <Form.Label>Mobile Number</Form.Label>

            <InputGroup>
              <InputGroup.Text className="d-flex align-items-center gap-2">
                <img
                  src={
                    CountryData.find((x) => x.countryID === countryID)?.flagPath
                  }
                  alt="flag"
                  width="20"
                  height="14"
                  style={{ objectFit: "cover" }}
                />

                {countryDialCode}
              </InputGroup.Text>

              <Form.Control
                placeholder="Enter mobile number"
                maxLength={10}
                {...register("mobileNumber", {
                  onChange: (e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setValue("mobileNumber", value);

                    clearErrors();
                  },
                })}
                isInvalid={errors.mobileNumber}
              />
            </InputGroup>

            <Form.Control.Feedback type="invalid">
              {errors.mobileNumber?.message}
            </Form.Control.Feedback>
          </Form.Group>

          {/* BUTTON */}

          <Button
            type="submit"
            className="w-100 fw-bold"
            style={{
              background: "#FF4F00",
              border: "none",
              padding: "10px",
            }}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Submit"}
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default ForgetPassword;
